import {
  SUBSCRIBE_PRICE_ALERT_COIN_SPOT,
  UNSUBSCRIBE_PRICE_ALERT_COIN_SPOT,
} from 'actionTypes/socket';
import createAction from 'helpers/createAction';

export const SELECT_PRICE_ALERT_COIN = 'SELECT_PRICE_ALERT_COIN';

export const subscribeSelectedCoinSpotPrice = createAction<Record<'symbol', string>>(
  SUBSCRIBE_PRICE_ALERT_COIN_SPOT
);

export const unsubscribeSelectedCoinSpotPrice = createAction<Record<'symbol', string>>(
  UNSUBSCRIBE_PRICE_ALERT_COIN_SPOT
);

export const selectPriceAlertCoin = createAction<Record<'symbol', string | null>>(
  SELECT_PRICE_ALERT_COIN
);
